import { IFiltersSections } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/filters/interfaces/sections/filters-sections.interface';

export const USERS_FILTERS_SECTIONS: IFiltersSections = {
  name: 'users',
  shortCode: 'users',
  sections: [
    {
      options: [
        {
          filterMethod: 'keywords',
          filterPropertyKeys: ['search'],
          filterMethodConfig: {
            useForSearch: true,
            title: 'Search',
            label: 'By name or ID',
          },
        },
      ],
    },
  ],
};
